import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Toggle from '../../../components/common/toggleButton';
import { getNumberPattern } from '../../utils/helper';
import InputField from '../../../components/common/input-field';
import { MarginType } from './NewMargin';

interface IProps {
  value: MarginType;
  onChange: (_value: MarginType) => void;
  title?: string;
}

const NewMarginFiled: React.FC<IProps> = ({
  value,
  onChange,
  title = 'Customize Margin',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 pagebuilder-theme"
        onClick={toggleAccordion}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out w-full ${isOpen ? 'max-h-screen' : 'max-h-0'}`}>
        <div className="grid gap-4 border border-gray-300 rounded p-2 w-full">
          <Toggle<MarginType>
            value={value}
            onChange={newValue => onChange({ ...value, ...newValue })}
            heading={{ label: 'Device', value: 'device' }}
            options={[
              { label: 'Desktop', value: 'desktop' },
              { label: 'Tablet', value: 'tablet' },
              { label: 'Mobile', value: 'mobile' },
            ]}
            propName="deviceType"
          />
          <div className="grid grid-cols-[1fr_1fr] gap-2">
            {' '}
            <InputField
              value={value.marginTop[value.deviceType]}
              onChange={e => {
                const newValue = getNumberPattern(e, true);
                onChange({
                  ...value,
                  marginTop: {
                    ...value.marginTop,
                    [value.deviceType]: newValue || '',
                  },
                });
              }}
              onBlur={() => {
                if (
                  !value.marginTop[value.deviceType] ||
                  value.marginTop[value.deviceType] === '-'
                ) {
                  onChange({
                    ...value,
                    marginTop: {
                      ...value.marginTop,
                      [value.deviceType]: '0',
                    },
                  });
                }
              }}
              className="h-[42px]"
              label="Top"
            />
            <InputField
              value={value.marginBottom[value.deviceType]}
              onChange={e => {
                const newValue = getNumberPattern(e, true);
                onChange({
                  ...value,
                  marginBottom: {
                    ...value.marginBottom,
                    [value.deviceType]: newValue || '',
                  },
                });
              }}
              onBlur={() => {
                if (
                  !value.marginBottom[value.deviceType] ||
                  value.marginBottom[value.deviceType] === '-'
                ) {
                  onChange({
                    ...value,
                    marginBottom: {
                      ...value.marginBottom,
                      [value.deviceType]: '0',
                    },
                  });
                }
              }}
              className="h-[42px]"
              label="Bottom"
            />
            <InputField
              value={value.marginLeft[value.deviceType]}
              onChange={e => {
                const newValue = getNumberPattern(e, true);
                onChange({
                  ...value,
                  marginLeft: {
                    ...value.marginLeft,
                    [value.deviceType]: newValue || '',
                  },
                });
              }}
              onBlur={() => {
                if (
                  !value.marginLeft[value.deviceType] ||
                  value.marginLeft[value.deviceType] === '-'
                ) {
                  onChange({
                    ...value,
                    marginLeft: {
                      ...value.marginLeft,
                      [value.deviceType]: '0',
                    },
                  });
                }
              }}
              className="h-[42px]"
              label="Left"
            />
            <InputField
              value={value.marginRight[value.deviceType]}
              onChange={e => {
                const newValue = getNumberPattern(e, true);
                onChange({
                  ...value,
                  marginRight: {
                    ...value.marginRight,
                    [value.deviceType]: newValue || '',
                  },
                });
              }}
              onBlur={() => {
                if (
                  !value.marginRight[value.deviceType] ||
                  value.marginRight[value.deviceType] === '-'
                ) {
                  onChange({
                    ...value,
                    marginRight: {
                      ...value.marginRight,
                      [value.deviceType]: '0',
                    },
                  });
                }
              }}
              className="h-[42px]"
              label="Right"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NewMarginFiled;
